<div class="px-2 pt-3">
  <div class="bom-table alternates-content">
    <h5 class="alternates-title">Sierra Recommended Alternates</h5>
    <p class="alternates-decription">(Why? These parts are immediately available and have equal or better
      tolerance than your specified
    parts.)</p>
    <table class="table-row table border table-striped">
      <thead>
        <tr>
          <th class="text-center" rowspan="2">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" value="" name="dataSelection" id="dataSelect" [(ngModel)]="headerCheck" (click)="selectedSuggItems('All')" >
            </div>
          </th>
          <th class="text-center" rowspan="2">Item #</th>
          <th class="text-center" rowspan="2">Original Part Details</th>
          <th class="text-center remarks-col" rowspan="2">Remarks</th>
          <th class="text-center" colspan="2">Sierra Recommended Alternates</th>
        </tr>
        <tr>
          <th class="text-center">MPN</th>
          <th class="text-center">Part Description</th>
        </tr>
      </thead>
      @if (commonService.commonMainObj.sierraRecommendations.length > 0) {
        <tbody>
          @for (issuesObj of commonService.commonMainObj.sierraRecommendations; track issuesObj) {
            <tr>
              <td class="text-center">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" name="dataSelection" id="dataSelect2" [(ngModel)]="issuesObj.checkedModel" (click)="selectedSuggItems('')" color="light" style="z-index: 1">
                </div>
              </td>
              <td class="text-center">{{issuesObj.itemNo}}</td>
              <td>
                <p class="details-label">{{issuesObj.originalPartDetails.mpn}}</p>
                <p class="details-text mb-0"><i>{{issuesObj.originalPartDetails.referenceDesignator}}</i></p>
              </td>
              <td><span class="nagative">{{issuesObj.remarks}}</span></td>
              <td><span class="font-w-500">{{issuesObj.sierraSuggestedAlternateDetails.mpn}}</span></td>
              <td><span class="font-w-500">{{issuesObj.sierraSuggestedAlternateDetails.description}}</span></td>
            </tr>
          }
        </tbody>
      }
      @if (commonService.commonMainObj.sierraCustomRecommendations.length > 0) {
        <tbody>
          @for (issuesObj of commonService.commonMainObj.sierraCustomRecommendations; track issuesObj) {
            <tr>
              <td class="text-center">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="" name="dataSelection" id="dataSelect2" [(ngModel)]="issuesObj.checkedModel" (click)="selectedSuggItems('')" color="light" style="z-index: 1">
                </div>
              </td>
              <td class="text-center">{{issuesObj.itemNo}}</td>
              <td>
                <p class="details-label">{{issuesObj.mpn}}</p>
                <p class="details-text mb-0"><i>{{issuesObj.refDes}}</i></p>
              </td>
              <td><span class="nagative">{{issuesObj.sierraRecommendedRemarks}}</span></td>
              <td><span class="font-w-500">{{issuesObj.sierraRecommendedMpn}}</span></td>
              <td><span class="font-w-500">{{issuesObj.sierraRecommendedPartDescription}}</span></td>
            </tr>
          }
        </tbody>
      }
    </table>
  </div>
</div>